// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Step_wrap__D6Zr5","full":"Step_full__3Fwx3","body":"Step_body__3EHWI","inner":"Step_inner__2fGwB","head":"Step_head__3KnyF"};